// @flow
import { CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_BACKEND_NAME } from '@src/constants';
import { GLOBAL_DISCOUNT_MAX_THRESHOLD_FOR_NON_ADMIN } from '@streaming-projects/constants';
import { getIn } from 'formik';

export const checkIfGlobalDiscountExceedsThresholdForNonAdminWhenTouched = ({
  isAdminUser,
  formik,
}) => {
  const currentValue = getIn(formik.values, CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_BACKEND_NAME);
  const initialValue = getIn(formik.initialValues, CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_BACKEND_NAME);
  const isTheValueUnChanged = Number(currentValue) !== Number(initialValue);
  return (
    !isAdminUser &&
    isTheValueUnChanged &&
    currentValue > GLOBAL_DISCOUNT_MAX_THRESHOLD_FOR_NON_ADMIN
  );
};
